
export const ADDRESSES = {
    BAYC: "0x1dA89342716B14602664626CD3482b47D5C2005E",
    NEFTURIANS: "0x9bAADf70BD9369F54901CF3Ee1b3c63b60F4F0ED",
    MEEBITS: "0xD1d148Be044AEB4948B48A03BeA2874871a26003",
    MEEBITS_CLAIMER: "0x5341e225Ab4D29B838a813E380c28b0eFD6FBa55",
  };
  
  export const ABIS = {
    BAYC: [
      "function name() view returns (string)",
      "function totalSupply() view returns (uint256)",
      "function claimAToken() external",
      "function tokenURI(uint256 tokenId) view returns (string)",
      "function ownerOf(uint256 tokenId) view returns (address)",
    ],
    NEFTURIANS: [
      "function tokenPrice() view returns (uint256)",
      "function buyAToken() external payable", 
      "function balanceOf(address owner) view returns (uint256)",
      "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)", 
      "function tokenURI(uint256 tokenId) view returns (string)",
    ],
    MEEBITS: [
      "function ownerOf(uint256 tokenId) view returns (address)",
    ],
    MEEBITS_CLAIMER: [
      "function claimAToken(uint256 tokenId, bytes calldata signature) external",
    ],
  };